export default __webpack_public_path__ + "static/media/padme-min.87d48d3a.webp";